import { render, staticRenderFns } from "./common-not-found.component.vue?vue&type=template&id=6f6ec006&"
import script from "./common-not-found.component.ts?vue&type=script&lang=js&"
export * from "./common-not-found.component.ts?vue&type=script&lang=js&"
import style0 from "./common-not-found.component.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
